const routes = [
    {
        name: 'digital_human_settings.index',
        path: '/digital-human-settings',
        component: () => {
            return import('@/views/digital_human/digital_human_settings/Index');
        },
        meta: {
            loadInModal: true,
            actions: true,
            breadcrumbName: 'select community settings',
            title: 'digital human settings',
            size: 'normal',
            flowStartsWith: 'digital_human_settings.index',
            allowedRoles: ['CUSTOMER_ADMIN', 'SUPER_ADMIN', 'USER'],
            requiredAppAccess: ['MIA'],
            product: 'dh',
        },
    },
];

export default routes;
